var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('i',{staticClass:"el-icon-success"}),_c('span',[_vm._v("欢迎使用管理后台")])])}]

export { render, staticRenderFns }